import { prop, required } from '@rxweb/reactive-form-validators';

export class UnidadesModel {
    @required()
    name: string;

    @prop({name: 'routes_id'})
    routeId: string;

    @required()
    active: string;
}
